import Image from 'components/FutureImage';
import { useEffect, useState } from 'react';

export default function MdxImage(props) {
  const [loading, setLoading] = useState(true);
  const [src, setSrc] = useState(props.src);
  useEffect(() => setSrc(props.src), [props.src]); // update the `src` value when the `prop.src` value changes

  return (
    <Image
      {...props}
      placeholder="blur"
      blurDataURL={
        props.blurDataURL ||
        'data:image/webp;base64,AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA='
      }
      src={src}
      alt={props.alt}
      className={`tw-mb-4 tw-rounded-lg tw-max-w-full tw-h-auto tw-border tw-border-solid tw-border-gray-200 ${
        loading ? 'tw-blur-[2px]' : 'tw-blur-0'
      }`}
      onLoadingComplete={async () => {
        setLoading(false);
      }}
      onError={() => {
        setSrc(`https://avatar.vercel.sh/${props.alt}`); // if the image fails to load, use the default avatar
      }}
    />
  );
}
